import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { 
  Lock as LockIcon, 
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon 
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage:
          `linear-gradient(to bottom right, rgba(245, 188, 188, 0.85), rgba(236, 117, 109, 0.8)), url('/images/auth-bg.jpg')`,
        backgroundSize: 'cover',
        p: 2
       
      }}
    >
      <Container maxWidth="sm">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Paper
            elevation={isMobile ? 0 : 6}
            sx={{
              p: 4,
              borderRadius: 4,
              backdropFilter: 'blur(10px)',
              backgroundColor: theme.palette.mode === 'dark' 
                ? 'rgba(30, 30, 30, 0.8)' 
                : 'rgba(255, 255, 255, 0.8)',
              border: theme.palette.mode === 'dark'
                ? '1px solid rgba(255, 255, 255, 0.1)'
                : '1px solid rgba(0, 0, 0, 0.1)'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 2
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  mb: 2
                }}
              >
                <LockIcon
                  sx={{
                    fontSize: 80,
                    color: theme.palette.error.main,
                    opacity: 0.9
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    boxShadow: `0 0 20px ${theme.palette.error.main}`,
                    animation: 'pulse 2s infinite'
                  }}
                />
              </Box>

              <Typography
                variant="h4"
                component="h1"
                sx={{
                  fontWeight: 700,
                  background: theme.palette.mode === 'dark'
                    ? 'linear-gradient(45deg, #FF8A80, #FF5252)'
                    : 'linear-gradient(45deg, #D32F2F, #F44336)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1
                }}
              >
                Access Restricted
              </Typography>

              <Typography
                variant="subtitle1"
                sx={{
                  color: theme.palette.text.secondary,
                  mb: 3,
                  maxWidth: '80%'
                }}
              >
                 You need to be logged in to view this page. Please sign in to continue exploring.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  flexDirection: isMobile ? 'column' : 'row',
                  width: isMobile ? '100%' : 'auto'
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => navigate(-1)}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    width: isMobile ? '100%' : 'auto'
                  }}
                >
                  Go Back
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<HomeIcon />}
                  onClick={() => navigate('/')}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    width: isMobile ? '100%' : 'auto',
                    borderWidth: 2,
                    '&:hover': {
                      borderWidth: 2
                    }
                  }}
                >
                  Home Page
                </Button>
              </Box>
            </Box>
          </Paper>
        </motion.div>
      </Container>

      {/* Add global styles for the pulse animation */}
      <style jsx global>{`
        @keyframes pulse {
          0% {
            transform: scale(0.95);
            opacity: 0.6;
          }
          50% {
            transform: scale(1);
            opacity: 0.3;
          }
          100% {
            transform: scale(0.95);
            opacity: 0.6;
          }
        }
      `}</style>
    </Box>
  );
};

export default UnauthorizedPage;